<!-- 修改反馈 -->
<template>
  <div>
    <zlr-modal v-model="feedbackModal">
      <div style="width:960px;">
        <div class="title">
          <p>修改反馈</p>
          <div>申请支持专家：{{detail.expertName}}</div>
        </div>
        <div>
          <editor ref="feedbackEditor"
                  :cache=false
                  v-model="fromData.editFeedback" />
        </div>
        <div class="select-modify">
          <RadioGroup v-model="fromData.menteeEditType">
            <Radio label="MENTOR"
                   style="margin-right:56px;">提交导师修改</Radio>
            <Radio label="EXPERT">专家再次修改</Radio>
          </RadioGroup>
        </div>
        <div class="btn-content">
          <Button type="primary"
                  class="zlr-btn-primary"
                  style="margin-right:24px;"
                  @click="handlerSub"
                  :loading="isLoading">提交</Button>
          <Button class="zlr-btn-default"
                  @click="feedbackModal = false">关闭</Button>
        </div>
      </div>
    </zlr-modal>
  </div>
</template>

<script>
// components
import ZlrModal from '_c/modal/modal'
import Editor from '_c/editor/editor'
// api
import { subExpertModifyEssay } from '@/api/expert'
export default {
  name: '',
  components: {
    ZlrModal,
    Editor
  },
  data () {
    return {
      feedbackModal: false,
      fromData: {
        menteeEditType: 'EXPERT',
        editFeedback: ''
      },
      detail: {},
      isLoading: false
    }
  },
  computed: {},
  mounted () { },
  methods: {
    show (data) {
      this.detail = data
      this.feedbackModal = true
      this.$nextTick(() => {
        this.$refs['feedbackEditor'].resetHtml()
      })
    },
    handlerSub () {
      let params = { ...this.fromData }
      params.id = this.detail.id
      this.isLoading = true
      subExpertModifyEssay(params).then(() => {
        this.$zlr_message('提交成功', 'success')
        this.feedbackModal = false
        this.$emit('on-success')
      }).catch((error) => {
        this.$zlr_message(error.message, 'error')
      }).then(() => {
        this.isLoading = false
      })
    }
  }
}
</script>
<style lang='less' scoped>
.title {
  margin-bottom: 32px;
  p {
    font-size: 24px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 36px;
    margin-bottom: 4px;
  }
  div {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.85);
    line-height: 24px;
  }
}
.select-modify {
  margin-top: 12px;
  margin-bottom: 36px;
}
</style>
